import { render, staticRenderFns } from "./TableFooterPagination.vue?vue&type=template&id=4011e03b&"
import script from "./TableFooterPagination.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableFooterPagination.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4011e03b')) {
      api.createRecord('4011e03b', component.options)
    } else {
      api.reload('4011e03b', component.options)
    }
    module.hot.accept("./TableFooterPagination.vue?vue&type=template&id=4011e03b&", function () {
      api.rerender('4011e03b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/TableFooterPagination.vue"
export default component.exports